export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

/**
 * Extracts UTM parameters from the URL and persists them to sessionStorage.
 * This should be called on the initial app load.
 */
export const persistUTMs = () => {
  if (typeof window === "undefined" || !window.location || !window.sessionStorage) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  let hasUtms = false;

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      window.sessionStorage.setItem(key, value);
      hasUtms = true;
    }
  });

  return hasUtms;
};

/**
 * Retrieves all saved UTM parameters from sessionStorage.
 * Returns an object with the keys that have values.
 */
export const getUTMs = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return {};
  }

  const utms = {};
  UTM_KEYS.forEach((key) => {
    const value = window.sessionStorage.getItem(key);
    if (value) {
      utms[key] = value;
    }
  });

  return utms;
};
